import { Cell } from '@/components/Bicester/Table/Cells/index';
import _ from 'lodash';
import { IconButton } from 'rsuite';
import Image from '@/components/Bicester/Image';
import React from 'react';
import { LEVEL_TYPE, ROLE_TYPE } from '@/constants';
import { ACCOUNT_TABS } from '@/views/CustomerAccount';
import { getPathname } from '@/utils/history';
import { useReadyInfo } from '@/providers/ReadyProvider';

export interface UserNameCellProps {
  rowData?: BaseObject<any>;
  dataKey: string;
}

const UserNameCell = ({ rowData, dataKey, ...props }: UserNameCellProps) => {
  const { profile } = useReadyInfo();
  const userName = _.get(rowData, dataKey, '');

  return (
    <Cell {...props}>
      <div className="flex items-center">
        <div className="text-[14px] overflow-hidden overflow-ellipsis">{userName}</div>
        {((rowData?.member_id !== 0 && !_.isNil(rowData?.member_id)) ||
          (rowData?.not_member_id !== 0 && !_.isNil(rowData?.not_member_id))) &&
          // GE兼职和OPS安保没有用户信息页面跳转按钮
          ![ROLE_TYPE.PT, ROLE_TYPE.OPS].includes(profile?.role) && (
            <IconButton
              className="ml-[5px] min-w-[13px]"
              onClick={() => {
                const isMember = rowData?.level !== LEVEL_TYPE.NOT;
                window.open(
                  getPathname(
                    `/customer-account/${
                      isMember ? ACCOUNT_TABS.MEMBER : ACCOUNT_TABS.NO_MEMBER
                    }/detail/${isMember ? rowData?.member_id : rowData?.not_member_id}`
                  )
                );
              }}
            >
              <Image
                src={`/resources/images/user${
                  rowData?.sex === '男' ? '-man' : rowData?.sex === '女' ? '-woman' : ''
                }.svg`}
              />
            </IconButton>
          )}
      </div>
    </Cell>
  );
};

export default UserNameCell;
